<template>
  <div>
    <div class="l-row">
      <form-group label="Status" :columns="6" :required="true">
        <select v-model="options.status" class="form-select">
          <option :value="null">Selecione</option>
          <option v-for="status in statuses" :value="status">
            {{ $t(`mercadoLivre.actions.status.${status}.label`) }}
          </option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      options: {
        status: null
      },
      statuses: [
        'activate',
        'pause'
      ]
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      getOptions () {
        return this.options
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .form-checkbox
    margin-top: 10px
</style>



// WEBPACK FOOTER //
// Options.vue?54301fb4